import { SxProps, Theme } from '@mui/material';
import { AI_GRADIENT_CSS } from 'common/constants/ai';
import theme from 'theme';

export const actionsContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
  padding: '16px 24px',
};

export const acceptAllButtonSx: SxProps<Theme> = {
  background: AI_GRADIENT_CSS,
  color: theme.palette.white,
  fontWeight: 600,
  textTransform: 'uppercase',
  padding: '8px 16px',
  '&:hover': {
    background: AI_GRADIENT_CSS,
    opacity: 0.9,
  },
  '&.Mui-disabled': {
    background: theme.palette.grey[300],
    color: theme.palette.grey[500],
  },
};

export const confirmationBodySx: SxProps<Theme> = {
  padding: '8px 24px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};
